import dateFormat from 'dateformat';

import parseDate from './parseDateToTimeStamp';

export default (dateString) => {
    if (!dateString) return '-';
    return dateFormat(parseDate(dateString), 'mediumDate', true);
};
